<div class="container no-print py-3">
    <div class="row link-row d-flex flex-column-reverse flex-md-row">
        <div class="col-12 col-md-6 d-flex flex-column justify-content-center text-center text-md-start mt-3 mt-md-0">
            <div class="small copyright">© A.W.G. Dewar, Inc. 2025. All rights reserved.</div>
            <p class="small disclaimer">CA License No. 0021741</p>
        </div>
        <div class="col-12 col-md-6 d-flex flex-column align-items-center align-items-md-end">
            <div class="navbar-nav d-flex flex-row justify-content-center justify-content-md-end mb-2 mb-md-0">
                <a class="nav-link me-2" [routerLink]="'/terms-conditions'">Terms &amp; Conditions</a>
                <a class="nav-link" [routerLink]="'/privacy-policy'">Privacy Policy</a>
            </div>
        </div>
    </div>
</div>
